import React, { useState } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// import debounce from "debounce";

// components
import MainLayout from "../components/hoc/MainLayout";

// Helpers
import { apiGet } from "../helpers/api";

const useStyles = makeStyles(() => ({
  table: { minWidth: 650 },
}));

function Riders() {
  const classes = useStyles();

  const [riders, setRiders] = useState([]);

  const fetchRiders = async () => {
    if (riders.length > 0) {
      return null;
    }

    try {
      const response = await apiGet("/admin/riders");
      setRiders(response.data.data);
    } catch (err) {
      console.log(err.response?.data?.message);
    }
  };

  React.useEffect(() => {
    fetchRiders();
  });

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Manage Riders
      </Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Email Address</TableCell>
              <TableCell align="left">First Name</TableCell>
              <TableCell align="left">Last Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {riders.map((rider) => (
              <TableRow key={rider.id}>
                <TableCell>{rider.email}</TableCell>
                <TableCell align="left">{rider.firstName}</TableCell>
                <TableCell align="left">{rider.lastName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default MainLayout(Riders, true);
